import { Component, OnInit } from '@angular/core';
import { AuthService, Profile } from '../services/auth.service';
import { AppComponent } from '../app.component';
import { AppMainComponent } from '../app.main.component';
import { AuthGuard } from '../services/auth.service';

@Component({
	selector: 'app-topbar',
	templateUrl: './app.topbar.component.html',
})
export class AppTopBarComponent implements OnInit {
	menu: unknown[];

	initials: string;
	username: string;
	email: string;

	constructor(
		public app: AppComponent,
		public appMain: AppMainComponent,
		private authService: AuthService,
		private authGuard: AuthGuard,
	) {}

	ngOnInit() {
		this.authService.loadUserProfile().then((profile: Profile) => {
			this.username = profile.username;
			this.email = profile.email;
			this.initials = profile.initials;
		});
	}

	onLogoutClick() {
		this.authService.logout();
	}
}
